/**
 * 晋级奖励
 */

import { RewardStatusEnum, RewardTypeEnum } from "@/types/reward";
import { RewardIcon } from "./reward-icon";
import { Button } from "@/components/ui/button";
import { useBalanceFormatter } from "@/hooks/use-balance-formatter";
import { useTranslations } from "next-intl";
import { useVipLevelLabel } from "@/features/vip/hooks/useVipLevelLabel";
import { useClaimDebounce } from "./use-claim-debounce";

interface VipUpgradeRewardProps {
  status: RewardStatusEnum;
  currency: string;
  amount: number;
  userLevel: number;
  claimCurrency: string;
  claimAmount: number;
  bonusWagerMultiple?: number;
  calendarAmount?: number;
  onClaim: () => Promise<unknown>;
}

export const VipUpgradeReward = (props: VipUpgradeRewardProps) => {
  const { status, currency, amount, userLevel, onClaim } = props;
  const { formatCurrencyDetail } = useBalanceFormatter();
  const t = useTranslations('reward');
  const { getLevelLabel } = useVipLevelLabel();
  const { loading, run } = useClaimDebounce(onClaim);

  if (status !== RewardStatusEnum.CLAIM) {
    return null;
  }

  const handleClaim = async () => {
    return run();
  };

  return (
    <div className="bg-dark-special rounded-lg py-3 pr-3 flex items-center justify-between" style={{ background: 'linear-gradient(to bottom right, #1D3657 0%, #1B2131 65%, #1B2131 100%)', }}>
      <RewardIcon type={RewardTypeEnum.PROMOTION_REWARD} className="mr-2.5" />
      <div className="flex-1 text-xs font-medium leading-3">
        <div className="text-white">Vip {getLevelLabel(userLevel)} {t('bonus')}</div>
        {!!amount && <div className="text-[#FFC600] text-xss mt-3 font-medium">{formatCurrencyDetail(amount)} {currency}</div>}
      </div>
      <Button
        variant="success"
        size='sm'
        className="w-[90px] ml-[10px]"
        disabled={loading}
        loading={loading}
        onClick={handleClaim}>
        {t('claim')}
      </Button>
    </div>
  );
};
